import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=255a4a78&scoped=true&lang=pug"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=255a4a78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a4a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('255a4a78')) {
      api.createRecord('255a4a78', component.options)
    } else {
      api.reload('255a4a78', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=255a4a78&scoped=true&lang=pug", function () {
      api.rerender('255a4a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Pagination.vue"
export default component.exports